import * as React from 'react'

import type { ShipmentNoteFeedItem } from '#/entities/shipment'
import { HistoryAppTag, HistoryRating, NoteRow } from '#/shared/ui/history-row'
import { RichText } from '#/shared/ui/rich-text'

function noteMeta(note: ShipmentNoteFeedItem): React.ReactNode[] {
  const meta: React.ReactNode[] = [note.timestamp]
  if (note.isApp) meta.push(<HistoryAppTag />)
  else if (note.author) meta.push(note.author)
  if (note.rating) meta.push(<HistoryRating value={note.rating} />)
  return meta
}

export function NoteHistoryRow({ note }: { note: ShipmentNoteFeedItem }) {
  return <NoteRow title={<RichText html={note.text} />} meta={noteMeta(note)} />
}
